import moment from 'moment'
import client from '../apollo'
import {
  GET_AUDIO_STREAM_UI_CONTEXT,
  GET_MODAL
} from '../apollo/actions'
import {
  LO_STO,
  SESH_STO,
  generateSuki64bitID,
  stripIds,
  logout
} from '../lib'
import loSto from '../config/loSto'
import seshSto from '../config/seshSto'
import { logger } from '../lib/logging'
import { Constants } from '@sukiai/components'
const { MODALS } = Constants

/**
 * Overall configuration for an audio stream, which is comprised of two stanzas:
 * - Context: Relays pertinent stateful information about the UI for captionstream
 * - Format: Audio encoding related details such as bitrate, sample rate...
 * - [TODO] Also hook up the route change listener to restart audio stream on view/context changes (maybe lazily?)
 */
export const getNewAudioStreamConfiguration = (format, isNewStream) => ({
  context: getNewStreamContext(isNewStream),
  format
})

/**
 * Every new audio stream, we need to resend the configuration and UI context
 */
export const getNewStreamContext = isNewStream => {
  // If there's no sessionId, log the user out
  const sessionId = loSto.get(LO_STO.SESSION_ID)
  if (!sessionId) {
    console.log('thomasnguyen logoout here')
    logout()
    return
  }

  // We read the UI context directly from the cache
  const { audioStreamUIContext } = client.readQuery({
    query: GET_AUDIO_STREAM_UI_CONTEXT
  })

  const { modal } = client.readQuery({
    query: GET_MODAL
  })

  // Check if new stream start time is needed
  const newStreamStartTime = isNewStream ? moment().toISOString() : null
  const currentStreamStartTime = loSto.get(LO_STO.CURRENT_STREAM_START_TIME)
  loSto.set(LO_STO.CURRENT_STREAM_START_TIME, newStreamStartTime || currentStreamStartTime)

  const pbSections = audioStreamUIContext.problemBasedSections.map(s => s.idNamePair)

  let path = window.location.pathname
  if (audioStreamUIContext.transcription) {
    path = '/section_transcript'
  }

  if (modal?.open) {
    const modalType = modal?.content?.type
    if (
      modalType === MODALS.IM_DONE ||
      modalType === MODALS.SUBMIT_OPTIONS ||
      modalType === MODALS.IM_DONE_BYPASS_QA ||
      modalType === MODALS.PDF_SUBMIT ||
      modalType === MODALS.NO_ENCOUNTER ||
      modalType === MODALS.IM_DONE_PDF ||
      modalType === MODALS.SIGN_OFF
    ) {
      path = '/submission_panel'
    } else if (
      modalType === MODALS.ICD10_SEARCH ||
      modalType === MODALS.ICD10_PREVIEW ||
      modalType === MODALS.CONFIRM_CODES
    ) {
      path = '/diagnosis_view'
    } else if (
      modalType === MODALS.SCRIPT_DETAILS
    ) {
      path = '/script'
    }
  }

  const openModalsList = loSto.get('OPEN_MODALS')
  const whatCanISayIndex = openModalsList ? openModalsList.indexOf('whatCanISay') : null

  if (whatCanISayIndex !== null && whatCanISayIndex >= 0) {
    path = "/what_can_i_say_view"
  }

  const userId = loSto.get(LO_STO.USER_ID) || seshSto.session(SESH_STO.USER_ID)

  const newStreamContext = {
    // Configuration, Identifiers & Debug/Trace information
    path: stripIds(path),
    streamStartTime: newStreamStartTime || currentStreamStartTime,
    sessionOwnerId: userId,
    organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
    userAgent: window.navigator && window.navigator.userAgent,
    sessionId,
    // UI Context
    ...audioStreamUIContext,
    problemBasedSections: pbSections
  }

  // If new stream, generate speechId, otherwise reuse existing
  const traceId = isNewStream ? generateSuki64bitID() : null
  const currentTraceId = window.sessionStorage.CURRENT_SPEECH_ID

  if (isNewStream) {
    window.sessionStorage.CURRENT_SPEECH_ID = traceId
  }
  newStreamContext.speechId = traceId || currentTraceId

  logger.info(`Sending new audio stream context: ${JSON.stringify(newStreamContext)}`)

  return newStreamContext
}
